export default __webpack_public_path__ + "static/media/3.06ed6915.webp";